module.exports = __webpack_public_path__ + "static/img/kids_5.11bf5486.png";